import { Button } from "reactstrap";

const PageActionButton = ({
  color,
  onClick,
  text,
  disabled,
}: {
  color: string;
  onClick: (x?: any) => void;
  text: string;
  disabled?: boolean;
}) => {
  return (
    <Button
      className="btn-block btn-submit"
      style={{
        width: 180,
        borderWidth: 0,
        backgroundColor: color,
        marginTop: 10,
        fontSize: 16,
        marginRight: 10,
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </Button>
  );
};

export default PageActionButton;
